import { PATHS } from "@config/constants";
import MainLayout from "@layouts/MainLayout";
import SubLayout from "@layouts/SubLayout";
import LoginLayout from "@layouts/LoginLayout";
import HomePage from "@pages/HomePage";
// import BidPage from "@pages/BidPage";
import UpNextPage from "@pages/UpNextPage";
import HistoryPage from "@pages/HistoryPage";
import HistoryDetailPage from "@pages/HistoryDetailPage";
import ResultsPage from "@pages/ResultsPage";
import ResultDetailPage from "@pages/ResultDetailPage";
import RulesPage from "@pages/RulesPage";
import AccountPage from "@pages/AccountPage";
import LoginPage from "@pages/LoginPage";
import Terms from "@pages/Terms";
import Questions from "@pages/Questions";
import LandingPage from "@pages/LandingPage";
import DeliveryPage from "@pages/DeliveryPage";
import NewYearAndChristmas_2024 from "@pages/Events/NewYearAndChristmas_2024";
import NewYearAndChristmas_2025 from "@pages/Events/NewYearAndChristmas_2025";
import WorldCup2026 from "@pages/Events/MiniGame/Home";

// import RegisterPage from "@pages/RegisterPage";
// import ForgotPasswordPage from "@pages/ForgotPasswordPage";
// import ForgotPasswordOTPPage from "@pages/ForgotPasswordOTPPage";
// import VerifyOTPPage from "@pages/VerifyOTPPage";

export const ROUTES = [
  {
    path: PATHS.HOME_PAGE,
    layout: SubLayout,
    component: LandingPage,
    exact: true,
    private: true
  },
  {
    path: PATHS.BID_PAGE,
    layout: MainLayout,
    component: HomePage,
    exact: true,
    private: false
  },
  {
    path: PATHS.BID2_PAGE,
    layout: MainLayout,
    component: HomePage,
    exact: true,
    private: false
  },
  // {
  //   path: PATHS.BID_PAGE,
  //   layout: MainLayout,
  //   component: BidPage,
  //   exact: true,
  //   private: false
  // },
  {
    path: PATHS.UP_NEXT_PAGE,
    layout: SubLayout,
    component: UpNextPage,
    exact: true,
    private: false
  },
  {
    path: PATHS.HISTORY_PAGE,
    layout: SubLayout,
    component: HistoryPage,
    exact: true,
    private: false
  },
  {
    path: PATHS.HISTORY_DETAIL_PAGE,
    parentPath: PATHS.HISTORY_PAGE,
    layout: MainLayout,
    component: HistoryDetailPage,
    exact: false,
    private: false
  },
  {
    path: PATHS.RESULTS_PAGE,
    layout: SubLayout,
    component: ResultsPage,
    exact: true,
    private: false
  },
  {
    path: PATHS.RESULTS_DETAIL_PAGE,
    parentPath: PATHS.RESULTS_PAGE,
    layout: MainLayout,
    component: ResultDetailPage,
    exact: false,
    private: false
  },
  {
    path: PATHS.RULES_PAGE,
    layout: SubLayout,
    component: RulesPage,
    exact: true,
    private: false
  },
  {
    path: PATHS.ACCOUNT_PAGE,
    layout: SubLayout,
    component: AccountPage,
    exact: false,
    private: true
  },
  {
    path: PATHS.LOGIN_PAGE,
    layout: LoginLayout,
    component: LoginPage,
    exact: false,
    private: true
  },
  {
    path: PATHS.TERM_PAGE,
    layout: SubLayout,
    component: Terms,
    exact: false,
    private: true
  },
  {
    path: PATHS.QUESTIONS_PAGE,
    layout: SubLayout,
    component: Questions,
    exact: false,
    private: true
  },
  {
    path: `${PATHS.EVENT}/:id`,
    layout: SubLayout,
    component: NewYearAndChristmas_2024,
    exact: false,
    private: true
  },
  {
    path: `${PATHS.EVENT_2025}/:id`,
    layout: SubLayout,
    component: NewYearAndChristmas_2025,
    exact: false,
    private: true,
  },
  {
    path: `${PATHS.EVENT_WORLD_CUP_2026}/:id/:awardId?`,
    layout: SubLayout,
    component: WorldCup2026,
    exact: false,
    private: true,
  },
  // {
  //   path: PATHS.REGISTER_PAGE,
  //   layout: LoginLayout,
  //   component: RegisterPage,
  //   exact: false,
  //   private: true
  // },
  // {
  //   path: PATHS.FORGOT_PASSWORD_PAGE,
  //   layout: LoginLayout,
  //   component: ForgotPasswordPage,
  //   exact: false,
  //   private: true
  // },
  // {
  //   path: PATHS.FORGOT_PASSWORD_OTP_PAGE,
  //   layout: LoginLayout,
  //   component: ForgotPasswordOTPPage,
  //   exact: false,
  //   private: true
  // },
  // {
  //   path: PATHS.VERIFY_OTP_PAGE,
  //   layout: LoginLayout,
  //   component: VerifyOTPPage,
  //   exact: false,
  //   private: true
  // },
  {
    path: PATHS.DELIVERY_PAGE,
    layout: SubLayout,
    component: DeliveryPage,
    exact: true,
    private: true
  }
];
